"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEthnicityValueProvider = useEthnicityValueProvider;
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const classifiers_1 = require("../../classifiers");
function useEthnicityValueProvider(params) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return (0, classifiers_1.buildPublicDataValueProvider)({
        label: t('defaultClassifiers.ethnicity'),
        ...params,
        classifierName: 'ethnicity',
    });
}
